export default {
    api: [
      {
        name: 'addIntegral',
        method: 'POST',
        desc: '修改积分',
        path: '/addIntegral'
      },
      {
        name: 'detail',
        method: 'GET',
        desc: '积分列表-一个月',
        path: '/detail'
      },
    ],
    BASE_URL: '/crm/integral'
  }


// WEBPACK FOOTER //
// ./src/api/apis/member/integral.js